<template>
  <div class="table table-small">
    <div class="table-header">
      <div class="row" :class="{'expense': expenseProp, 'subscription': subscriptionProp}">
        <span class="column short-column">
          <span> {{ $lang.messages.defaultMsg }} </span>
        </span>
        <span
          v-if="expenseProp"
          class="column"
        >
          <span> {{ $lang.messages.accountNumber }} </span>
        </span>
        <span
          v-if="subscriptionProp"
          class="column"
        >
          <span> {{ $lang.messages.cardNumber }} </span>
        </span>
        <span class="column middle-column">
          <span> {{ $lang.messages.type }} </span>
        </span>
        <span
          v-if="subscriptionProp"
          class="column"
        >
          <span> {{ $lang.messages.expirationDate }} </span>
        </span>
        <span class="column">
          <span> {{ $lang.messages.dateAdded }} </span>
        </span>
        <span class="column short-column right-aligned-column">
          <span> {{ $lang.messages.actions }} </span>
        </span>
      </div>
    </div>
    
    <div class="table-body">
      
      <section v-if="mockData">
        <div
          v-for="(item, i) in repeatTimes"
          :key="i"
          class="row"
          :class="{'expense': expenseProp, 'subscription': subscriptionProp}"
        >
          <span class="column short-column right-padding">
            <div class="gradient-mask"></div>
          </span>
      
          <span class="column right-padding">
            <div class="gradient-mask"></div>
          </span>
      
          <span class="column right-padding" v-if="subscriptionProp">
            <div class="gradient-mask"></div>
          </span>
      
          <span class="column middle-column right-padding">
            <div class="gradient-mask"></div>
          </span>
      
          <span class="column right-padding">
            <div class="gradient-mask"></div>
          </span>
      
          <span class="column short-column right-column">
            <div class="gradient-mask"></div>
          </span>
        </div>
      </section>

      <section v-if="!mockData && list.length !== 0">
        <div
          v-for="(item, indexPayMethods) in list"
          :key="indexPayMethods"
          class="row"
          :class="{'expense': expenseProp, 'subscription': subscriptionProp}"
        >
          <span class="column short-column right-padding" v-if="expenseProp || subscriptionProp">
            <label class="radio-wrapper">
              <input
                v-if="radioNameProp === 'pay-methods'"
                :checked="item.default || item.defaultBankAccount"
                type="radio"
                disabled
                :name="radioNameProp"
              >
              <input
                v-else
                type="radio"
                :checked="item.defaultCreditCard"
                :name="radioNameProp"
                disabled
              >
              <span class="radio-checkmark"></span>
            </label>
          </span>
    
          <span class="column right-padding" v-if="expenseProp">
            <div class="column-name"> {{ $lang.messages.accountNumber }} </div>
            <span class="column-data" :title="item.bankAccountNumber"> {{ item.bankAccountNumber }} </span>
          </span>
    
          <div
            v-if="expenseProp"
            class="column-pair"
          >
            <span class="column middle-column right-padding">
              <div class="column-name"> {{ $lang.messages.type }} </div>
              <span class="column-data" :title="item.type"> {{ item.type }} </span>
            </span>
        
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.dateAdded }} </div>
              <span class="column-data" :title="dateFormat(item.date)"> {{ dateFormat(item.date) }} </span>
            </span>
          </div>
    
          <div
            v-if="subscriptionProp"
            class="column-pair"
          >
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.cardNumber }} </div>
              <span class="column-data" :title="item.cardNumber"> {{ item.cardNumber }} </span>
            </span>
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.type }} </div>
              <span class="column-data" :title="item.cardType"> {{ item.cardType }} </span>
            </span>
          </div>
    
          <div
            v-if="subscriptionProp"
            class="column-pair"
          >
            <span class="column middle-column right-padding">
              <div class="column-name"> {{ $lang.messages.expirationDate }} </div>
              <span class="column-data" :title="item.expirationDate"> {{ item.expirationDate }} </span>
            </span>
            
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.dateAdded }} </div>
              <span class="column-data" :title="dateFormat(item.dateAdded)"> {{ dateFormat(item.dateAdded) }} </span>
            </span>
          </div>
    
          <span
            class="column short-column actions-ico"
            @click="toggleActions(item, $event)"
          >
            <img
              v-if="subscriptionProp || (expenseProp && item.status === 'VERIFIED') || (bankAccountModalOpened && expenseProp && item.status === 'PENDING')"
              src="@/assets/images/payments/actions_ico.png"
            />
            
            <span v-if="!bankAccountModalOpened && expenseProp && item.status === 'PENDING'">
              <span class="blink"></span>
              <span class="image">
                <img
                    v-if="expenseProp"
                    src="@/assets/images/payments/actions_ico.png"
                />
              </span>
            </span>
            
            <f-p-registration-progress-tooltip
              v-if="!bankAccountModalOpened && expenseProp && item.status === 'PENDING'"
              :class="{'enabled' : true, 'back-account-tooltip' : true, 'arrow-tooltip--before': true}"
              class="tooltip"
              :text="$lang.messages.clickHereToFinishAddingBankAccount">
            </f-p-registration-progress-tooltip>

            <div
              v-if="subscriptionProp"
              class="action-menu"
              :class="[ actionsRowId === item.creditCardToken && actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]"
              id="actions-ico"
            >
              
              <div>
                <button
                  class="item btn-item btn-delete"
                  @click="deleteModalOpen(item.creditCardToken, 'card', 'deleteCard')"
                >
                  {{ $lang.messages.deleteMess }}
                </button>
              </div>
  
              <div>
                <button
                  class="item btn-item"
                  @click="makeDefaultCard(item.creditCardToken)"
                >
                  {{ $lang.messages.makeDefault }}
                </button>
              </div>
            </div>
            
            <div
              v-else
              :class="[ actionBankAccountId === item.id && actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]"
              class="action-menu"
            >
               <div>
                <button
                  class="item btn-item btn-delete"
                  @click="deleteModalOpen(item.id, 'account', 'deleteBankAccount')"
                >
                  {{ $lang.messages.deleteMess }}
                </button>
              </div>
  
              <div v-if="subscriptionProp || (expenseProp && item.status === 'VERIFIED')">
                <button
                  class="item btn-item"
                  @click="makeDefaultBankAccount(item.id)"
                >
                  {{ $lang.messages.makeDefault }}
                </button>
              </div>
              
              <div v-if="expenseProp && item.status === 'PENDING'">
                <button
                    class="item btn-item"
                    @click="finishAddingBankAccount()"
                >
                  {{ $lang.messages.finishAddingBankAccount }}
                </button>
              </div>
            </div>
            
          </span>
        </div>
      </section>
    </div>

    <!-- Delete Modal -->
    <delete-modal
      ref="deleteModalComponent"
      @deleteCard="deleteCard"
      @deleteBankAccount="deleteBankAccount"
    >
    </delete-modal>
  </div>
</template>

<script>
  import DeleteModal from "@/components/common/modals/DeleteModal"
  import FPRegistrationProgressTooltip from '@/components/common/FPRegistrationProgressTooltip';
  import {dateFormat} from "@/mixins/dateFormat";

  export default {
    name: "FPTablePaymentMethods",
    components: {
      DeleteModal,
      FPRegistrationProgressTooltip
    },
    mixins: [
      dateFormat
    ],
    props: {
      list: {
        type: Array,
        required: true,
        default: () => []
      },
      mockData: {
        type: Boolean,
        required: false,
        default: () => false
      },
      expenseProp: {
        type: Boolean,
        required: false,
        default: () => false
      },
      subscriptionProp: {
        type: Boolean,
        required: false,
        default: () => false
      },
      radioNameProp: {
        type: String,
        default: 'default'
      },
      bankAccountModalOpened: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },
    data() {
      return {
        actions: false,
        actionsRowId: 0,
        actionBankAccountId: 0,
        repeatTimes: 2,
        actionsTooltip: true
      };
    },
    mounted() {
      this.onClickOutside();
    },
    methods: {
      onClickOutside() {
        let _this = this;
        document.addEventListener('click', function(e) {
          let dropdown = document.querySelector('#actions-ico');
          let clickedElement = e.target;
          
          if (clickedElement.className.indexOf('item') !== 0) {
            if (clickedElement.className.indexOf('actions-ico') === -1 && clickedElement !== dropdown) {
              _this.actions = false;
            }
          }
        });
      },
      toggleActions(creditCardToken, e) {
        e.stopPropagation();
        // Braintree
        if (creditCardToken.creditCardToken) {
          this.actions = !this.actions;
          this.actionsRowId = creditCardToken.creditCardToken;
        } else {
        // Checkbook
          this.actions = !this.actions;
          this.actionBankAccountId = creditCardToken.id;
        }
      },
      deleteModalOpen(guid, type, typeOfDeletion) {
        this.$refs.deleteModalComponent.show(guid, type, typeOfDeletion);
      },
      //
      // Braintree subscription
      //
      deleteCard(creditCardToken) {
        this.$emit("deleteCard", creditCardToken)
      },
      makeDefaultCard(creditCardToken) {
        this.$emit("makeDefaultCard", creditCardToken)
      },
      //
      // Checkbook cards
      //
      deleteBankAccount(bankId) {
        this.$emit("deleteBankAccount", bankId)
      },
      makeDefaultBankAccount(bankId) {
        this.$emit('defaultBankAccount', bankId)
      },
      finishAddingBankAccount() {
        this.$emit('finishAddingBankAccount')
      },
    }
  };
</script>

